import React, { createRef } from 'react';
import moment from 'moment';
import { withSnackbar } from "notistack";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { LoopCircleLoading } from 'react-loadingg';
import InputAdornment from '@material-ui/core/InputAdornment';
import { getPrimaryColor } from '../Helper/CommonThings';
import StaffLocationViewRow from './StaffLocationViewRow';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const useStyles = (theme) => ({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)"
    }
  },
  root: {
    width: 'calc(100vw - 35px)',
  },
  container: {
    maxHeight: 410,
  },
  topSticky: {
    position: "sticky",
    top: '0px',
    background: " #F8F8F8",
    boxShadow: "5px 2px 5px grey"
  },
  topStickyDates: {
    position: "sticky",
    top: '68px',
    background: " #F8F8F8",
    boxShadow: "5px 2px 5px grey"
  },
  smallIcon: {
    padding: '5px'
  }
});

const months = { 0: 'January', 1: 'Febrauary', 2: 'March', 3: 'April', 4: 'May', 5: 'June', 6: 'July', 7: 'August', 8: 'September', 9: 'October', 10: 'November', 11: 'December' }
class StaffLocationViewHeader extends React.Component {
  constructor(props) {
    super(props)
    this.tableScrollRef = createRef()
    this.topRef = createRef()
    this.monthHeaderRefs = {}
    this.state = {
      allRoles: [],
      rolesObj: {},
      allEmp: [],
      empObj: {},
      columns: [],
      allMonths: [],
      selectedEndDate: !this.props.selectedStartDate ? null : this.props.selectedEndDate,
      selectedStartDate: !this.props.selectedEndDate ? null : this.props.selectedStartDate,
      templateRoles: [],
      selectedEmployee: "",
      employeeSearchField: "",
      roleSearchField: "",
      rawEmployeeSchedules: [],
      tabcelEdit: { empIndex: null, weekIndex: 0, showInputBox: false },
      editedWeekObj: {},
      searchLoading: false,
      scrollTop: false,
    }
    this.handleRefresh = this.handleRefresh.bind(this)
    this.addAllocation = this.addAllocation.bind(this)
  }

  handleRefresh() {
    this.props.refreshData()
  }

  componentDidMount() {
    let { allEmp, columns, allMonths, liveOpportunities } = this.props.roleData;
    this.setState({ templateRoles: this.props.templateRoles, allEmpCopy: allEmp, allEmp, columns, allMonths, liveOpportunities }, () => {
      this.scrollToCurrentMonth(false)
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.allMonths !== this.state.allMonths) {
      this.scrollToCurrentMonth(false)
    }
  }

  scrollToCurrentMonth = (smooth = false) => {
    const scrollContainer = this.tableScrollRef.current
    if (!scrollContainer || !this.state.allMonths?.length) {
      return
    }

    const currentMonthKey = `${months[moment().month()]} ${moment().year()}`
    const monthCell = this.monthHeaderRefs[currentMonthKey]
    if (!monthCell) {
      return
    }

    const stickyColumnsWidth = 400
    const targetScrollLeft = Math.max(monthCell.offsetLeft - stickyColumnsWidth, 0)
    scrollContainer.scrollTo({
      left: targetScrollLeft,
      behavior: smooth ? 'smooth' : 'auto'
    })
  }

  filterByName = (e) => {
    let allEmps = [...this.state.allEmp];

    let filteredByEmployees;
    filteredByEmployees = allEmps.filter(
      (emp) =>
        emp.name ?
          emp.name
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) : ''
    );

    if (e.target.value === "") {
      this.setState({
        allEmp: this.state.allEmpCopy,
        employeeSearchField: e.target.value,
        searchLoading: true
      }, () => this.setState({ searchLoading: false }));
    } else if (filteredByEmployees.length > 0) {
      this.setState({
        allEmp: filteredByEmployees,
        employeeSearchField: e.target.value,
        searchLoading: true
      }, () => this.setState({ searchLoading: false }))
    } else {
      this.props.enqueueSnackbar(
        "No Employees for the search!",
        {
          variant: "warning",
        }
      );
    }
  }

  filterByRole = (e) => {
    let allEmps = [...this.state.allEmp];

    let filteredByEmployees;
    filteredByEmployees = allEmps.filter(
      (emp) =>
        emp.project_role_name
          .toLowerCase()
          .includes(e.target.value.toLowerCase())
    );

    if (e.target.value === "") {
      this.setState({
        allEmp: this.state.allEmpCopy,
        roleSearchField: e.target.value,
        searchLoading: true
      }, () => this.setState({ searchLoading: false }));
    } else if (filteredByEmployees.length > 0) {
      this.setState({
        allEmp: filteredByEmployees,
        roleSearchField: e.target.value,
        searchLoading: true
      }, () => this.setState({ searchLoading: false }))
    } else {
      this.props.enqueueSnackbar(
        "No Roles for the search!",
        {
          variant: "warning",
        }
      );
    }
  }

  updateEmployeeRow = (empRowData, index) => {
    let allempp = [...this.state.allEmp]
    allempp[index] = empRowData
    this.setState({ allEmp: allempp })
  }

  includeLeaves(leavesArray, emp, columns) {
    let allEmployeeSchedules = [...emp.weekdata]
    if (leavesArray.length > 0) {
      for (let leaveindex = 0; leaveindex < leavesArray.length; leaveindex++) {
        for (let colindex = 0; colindex < columns.length; colindex++) {
          let date = moment(columns[colindex]['field'], 'DD/MM/YYYY').toISOString().slice(0, 10)
          if (leavesArray[leaveindex]['date'] === date) {
            if (allEmployeeSchedules[colindex]) {
              allEmployeeSchedules[colindex].leaves = leavesArray[leaveindex]
            }
          }
        }

      }
    }
    return allEmployeeSchedules
  }

  addAllocation(emp, prj) {
    if (this.props.addAllocation) {
      this.props.addAllocation(emp, prj)
    }
  }

  scrolltoTop() {
    if (this.topRef.current) {
      this.topRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  render() {

    const classes = this.props.classes;

    return (
      < div>
        {
          this.state.allEmp.length > 0 ?
            <>
              <div ref={this.tableScrollRef} style={{ overflowX: 'auto', width: '100%', maxHeight: window.innerHeight - 200 }} onScroll={(e) => {
                if (e.target.scrollTop > 50 && !this.state.scrollTop) {
                  this.setState({ scrollTop: true })
                } else if (e.target.scrollTop < 50 && this.state.scrollTop) {
                  this.setState({ scrollTop: false })
                }
              }}>
                <Table className={classes.table} stickyHeader style={{ tableLayout: 'fixed' }} ref={this.topRef}>
                  <TableHead>
                    <TableRow >
                      <TableCell
                        style={{ zIndex: 9999, background: "#F8F8F8", position: "sticky" }}
                        colSpan={2}
                        width={200}
                      >
                        <TextField
                          size='small'
                          onChange={(e) => this.filterByName(e)}
                          id="standard-basic"
                          label="Search Employee"
                          type="text"
                          variant="outlined"
                          value={this.state.employeeSearchField}
                          style={{
                            width: '150px',
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              {this.state.employeeSearchField ? (
                                <IconButton
                                  aria-label="close"
                                  size='small'
                                  onClick={() =>
                                    this.setState({
                                      employeeSearchField: "",
                                      allEmp: this.state.allEmpCopy,
                                    })
                                  }
                                >
                                  <CloseIcon fontSize='small' />
                                </IconButton>
                              ) : null}
                            </InputAdornment>
                          }
                        />
                      </TableCell>
                      <TableCell width={200} align="center" style={{ background: "#F8F8F8", left: '200px', position: 'sticky', zIndex: 9999 }}>
                        <TextField
                          size='small'
                          onChange={(e) => this.filterByRole(e)}
                          id="standard-basic"
                          label="Search Role"
                          type="text"
                          variant="outlined"
                          value={this.state.roleSearchField}
                          style={{
                            width: '150px',
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              {this.state.roleSearchField ? (
                                <IconButton
                                  aria-label="close"
                                  size='small'
                                  onClick={() =>
                                    this.setState({
                                      roleSearchField: "",
                                      allEmp: this.state.allEmpCopy,
                                    })
                                  }>
                                  <CloseIcon fontSize='small' />
                                </IconButton>
                              ) : null}
                            </InputAdornment>
                          }
                        />
                      </TableCell>
                      {this.state.allMonths.map(month => {
                        return <TableCell
                          key={month.month}
                          ref={(el) => { this.monthHeaderRefs[month.month] = el }}
                          colSpan={month.colSpan}
                          align='center'
                          width={month.width}
                        ><b>{month.month}</b></TableCell>
                      })}
                    </TableRow>
                    <TableRow >
                      <TableCell colSpan={2} width={200} align="center" style={{ background: "#F8F8F8", zIndex: 9999, top: 72 }}>
                        <b>{"Actions & Employee Name"}</b>
                      </TableCell>
                      <TableCell width={200} align="center" style={{ background: "#F8F8F8", position: "sticky", left: '200px', zIndex: 9999, top: 72 }}>
                        <b style={{ color: getPrimaryColor() }}>Employee Role</b>
                      </TableCell>
                      {this.state.columns.map((col, colIndex) => {
                        return <TableCell key={colIndex} align="center" style={{ top: 72 }}  ><b>{col.title}</b></TableCell>
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody >
                    {this.state.searchLoading ?
                      <LoopCircleLoading /> :
                      this.state.allEmp.map((emp, index) => {
                        let currentEmployeesLeaves = this.props.allEmployeesLeaves.filter(leave => leave.ptd_employee === emp.id)
                        let allEmployeeSchedules = this.includeLeaves(currentEmployeesLeaves, emp, this.state.columns);
                        return <StaffLocationViewRow
                          disciplineObj={this.props.disciplineObj}
                          roleData={this.props.roleData}
                          crm={this.props.crm}
                          type={this.props.type}
                          rolesObj={this.props.rolesObj}
                          refreshData={this.handleRefresh}
                          key={index}
                          columns={this.state.columns}
                          liveOpportunities={this.props.liveOpportunities}
                          allEmployeeSchedules={allEmployeeSchedules}
                          allLeaves={currentEmployeesLeaves}
                          emp={emp} index={index}
                          allProjects={this.props.allProjects}
                          allRoles={this.props.allRoles}
                          othertaskObject={this.props.othertaskObject}
                          allEmployeesLeaves={this.props.allEmployeesLeaves}
                          allOtherTasks={this.props.allOtherTasks}
                          selectedStartDate={this.state.selectedStartDate}
                          selectedEndDate={this.state.selectedEndDate}
                          projectObj={this.props.projectObj}
                          role={this.props.role?.id}
                          updateEmployeeRow={(empRowData) => this.updateEmployeeRow(empRowData, index)}
                          addAllocation={this.addAllocation}
                          roles={this.props.roles}
                        />
                      })}
                  </TableBody>
                </Table>
              </div>
            </>
            :
            <p style={{ textAlign: "center", padding: '20px' }}>No Employee available for this role.</p>
        }
        {this.state.scrollTop ? <IconButton size='large' onClick={() => { this.scrolltoTop() }} variant='contained' style={{ zIndex: 999, position: 'absolute', right: 40, bottom: 40 }}><ArrowUpwardIcon style={{ fontSize: '40px' }} /></IconButton> : null}
      </div >)
  }
}

export default withSnackbar(withStyles(useStyles)(StaffLocationViewHeader))
